/**
 * > When using the esBuild API, all `process.env.NODE_ENV` expressions
 * > are automatically defined to `"production"` if all minification
 * > options are enabled and `"development"` otherwise. This only happens
 * > if `process`, `process.env`, and `process.env.NODE_ENV` are not already
 * > defined. This substitution is necessary to avoid code crashing instantly
 * > (since `process` is a Node API, not a web API).
 * > — https://esbuild.github.io/api/#platform
 */

import { html } from './utils/environment';
import GPUTest from './utils/performances/GPUTest';
import CPUTest from './utils/performances/CPUTest';

// Environments
const env = process.env.NODE_ENV

// Device
const IS_MOBILE = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

const gpu = new GPUTest()
const cpu = new CPUTest()
cpu.callback = () => {
    config.LOW_PERFORMANCE = !window.hasGoodGPU || !window.hasGoodCPU
    html.classList.toggle('has-low-performance', config.LOW_PERFORMANCE)
}
cpu.run()

export default config = {
    // Environments
    ENV: env,
    IS_PROD: env === 'production',
    IS_DEV: env === 'development',

    // Device
    IS_MOBILE,
    LOW_PERFORMANCE: !window.hasGoodGPU || !window.hasGoodCPU,

    LANG: html.getAttribute('lang'),

    VUE_DELIMITERS: ['${', '}'],

    // // CSS class names
    // CSS_CLASS: {
    //     LOADED: 'is-loaded',
    //     LOADING: 'is-loading',
    //     READY: 'is-ready',
    // },
}
